export { default } from "./DeliveryDispensaryCards";
